import * as types from 'constants/ActionTypes';
import { xSelectSingle } from 'utils/xSelect';
import { list, save, create } from 'utils/Api';

export const requestBank = () => ({
  type: types.REQUEST_BANK,
});

export const requestBankSuccess = accounts => ({
  type: types.REQUEST_BANK_SUCCESS,
  accounts,
});

export const requestBankFailure = error => ({
  type: types.REQUEST_BANK_FAILURE,
  error,
});


export const requestBankBranches = () => ({
  type: types.REQUEST_BANK_BRANCHES,
});

export const setBankBranches = branches => ({
  type: types.SET_BANK_BRANCHES,
  branches,
});

export const fetchBankBranches = () =>
  (dispatch, getState) => {
    const {
      loginReducer: { user: { token } },
    } = getState();

    const config = {
      entity: 'SysBankBranch',
      headers: { Authorization: `Bearer ${token}` },
    };

    return list(config)
      .then(({ data }) => dispatch(setBankBranches(data)))
      .catch(err => dispatch(requestBankFailure(err)));
  };

export const fetch = () =>
  (dispatch, getState) => {
    dispatch(requestBank());
    dispatch(requestBankBranches());
    dispatch(fetchBankBranches());
    const {
      loginReducer: { user: { EmployeeMasterID, token } },
    } = getState();

    const config = {
      entity: 'EmployeeMasterBank',
      headers: { Authorization: `Bearer ${token}` },
      data: xSelectSingle([
        // TODO: Find solution for this
        { field: 'EmployeeMasterID', value: EmployeeMasterID, relation: 'eq' },
      ]),
    };

    return list(config)
      .then(({ data }) => dispatch(requestBankSuccess(data.filter(x => x.BankAccountType === 1 && new Date(x.Endda).getTime() > Date.now()))))
      .catch(err => dispatch(requestBankFailure(err)));
  };

export const setStatus = status => ({
  type: types.SET_ACCOUNT_STATUS,
  status,
});

export const createNewAccount = () => ({
  type: types.CREATE_NEW_ACCOUNT,
});

export const clearNewAccount = () => ({
  type: types.CLEAR_NEW_ACCOUNT,
});

export const requestbankupdate = () => ({
  type: types.REQUEST_BANK_UPDATE,
});

export const requestBankUpdateSuccess = account => ({
  type: types.REQUEST_BANK_UPDATE_SUCCESS,
  account,
});

export const requestBankUpdateFailure = error => ({
  type: types.REQUEST_BANK_UPDATE_FAILURE,
  error,
});

export const update = emb =>
  (dispatch, getState) => {
    /* Start the loading animation for the account that is being saved */
    dispatch(setStatus({ id: emb.EmployeeMasterBankID, value: 'ACCOUNT_SAVING' }));
    /* Check if the account is a new account */
    const isNew = emb.EmployeeMasterBankID === 'NEW_ACCOUNT';
    const data = emb;

    /* If the account is new we don't want to send the fake id to qdata */
    if (isNew) {
      delete data.EmployeeMasterBankID;
    }

    const { loginReducer: { user: { token, EmployeeMasterID } } } = getState();

    const config = {
      entity: 'EmployeeMasterBank',
      headers: { Authorization: `Bearer ${token}` },
      data: {
        ...data,
        EmployeeMasterID,
        BankAccountType: 1,
      },
    };

    /* If we are a new acount we need to create and not save */
    if (isNew) {
      create(config)
        .then((res) => {
        /* When created we need to remove the new account item from the view */
          dispatch(clearNewAccount());
          dispatch(requestBankUpdateSuccess(res.data));
        })
        .catch(error => dispatch(requestBankUpdateFailure(error)));
    } else {
      save(config)
        .then(res => dispatch(requestBankUpdateSuccess(res.data)))
        .catch(error => dispatch(requestBankUpdateFailure(error)));
    }
  };



// WEBPACK FOOTER //
// ./src/actions/EmployeeBank.js